import analytics from '@/shared-utils/analytics'
import { GA4Event, GA4Product } from '@/shared-utils/ga4/types'
import {
  ANALYTICS_CATEGORY_FLIGHTS,
  ANALYTICS_CATEGORY_HOME
} from '@/constants/analytics'

function fireGA4EventWithCommonAttributes(
  event: string,
  category?: string,
  additionalAttributes = {}
) {
  const pageName =
    category && category === ANALYTICS_CATEGORY_HOME ? 'homepage' : 'landing'
  analytics.fireGA4Event({
    event,
    attributes: {
      type: 'recent_activity',
      page_name: pageName,
      creative_name: 'pick_up_where_you_left_off',
      ...additionalAttributes
    }
  })
}

export default function fireTripActivityCardClickEvent(
  label: string,
  category: string
) {
  analytics.fireEvent({
    category,
    action: 'trip activity search click',
    label
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, category, {
    creative_slot: 'selection',
    product_name: label
  })
}

export function fireViewAllButtonClickEvent(category: string) {
  analytics.fireEvent({
    category,
    action: 'hotel selection',
    label: 'view all'
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, category, {
    creative_slot: 'selection'
  })
}

export function fireTripActivityLoadEvent(label: string, category: string) {
  analytics.fireEvent({
    category,
    action: 'trip activity search load',
    label
  })
  fireGA4EventWithCommonAttributes(GA4Event.VIEW_PROMOTION, category, {
    creative_slot: 'search',
    product_name: label
  })
}

export function fireAbandonedSelectionLoadEvent(
  category: string,
  label?: string
) {
  analytics.fireEvent({
    category,
    action: 'trip activity selection load',
    label
  })
  fireGA4EventWithCommonAttributes(GA4Event.VIEW_PROMOTION, category, {
    creative_slot: 'selection',
    product_name: label
  })
}

export function fireAbandonedSelectionClickEvent(
  category: string,
  label?: string
) {
  analytics.fireEvent({
    category,
    action: 'trip activity selection click',
    label
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, category, {
    creative_slot: 'selection',
    product_name: label
  })
}

export function fireFlightsOnContinueClickEvent() {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_FLIGHTS,
    action: 'flight recent search',
    label: 'continue search'
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, '', {
    creative_slot: 'selection',
    product_name: GA4Product.FLY
  })
}

export function fireOnBundleNowClickEvent() {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_FLIGHTS,
    action: 'flight recent search',
    label: 'bundle banner'
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, '', {
    creative_slot: 'selection',
    product_name: GA4Product.FLY
  })
}

export function fireOnBookABundleCheckboxClick() {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_FLIGHTS,
    action: 'flight recent search',
    label: 'checkbox search'
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, '', {
    creative_slot: 'selection',
    product_name: GA4Product.FLY
  })
}

export function fireOnCheckboxChangeEvent(name: string) {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_FLIGHTS,
    action: 'flight recent search',
    label: `select ${name}`
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, '', {
    creative_slot: 'selection',
    product_name: GA4Product.FLY
  })
}

export function fireFlightRecentSearchViewAllButtonClick() {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_FLIGHTS,
    action: 'flights selection',
    label: 'view all recent activity'
  })
  fireGA4EventWithCommonAttributes(GA4Event.CLICK_PROMOTION, '', {
    creative_slot: `selection`,
    product_name: GA4Product.FLY
  })
}
